import { backOff } from "exponential-backoff";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import {PostPromotionCodeRequest} from "../proto/api_pb";
import { RpcError } from "grpc-web";
import {PostPromotionCodeResponse} from  "../proto/api_pb";

export const submitPromoCode = async (
  accessToken: string,
  userId: string,
  promotionCode:string
): Promise<PostPromotionCodeResponse | RpcError | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new PostPromotionCodeRequest();
    request.setUserId(userId);
    request.setPromotionCode(promotionCode)
    const metadata = {
      Authorization: `${accessToken}`,
      "Access-Control-Allow-Origin": "*",
    };

    return await backOff(
      () =>
        new Promise<PostPromotionCodeResponse | RpcError>((resolve, reject) => {
          ommuseClient.postPromotionCode(
            request,
            metadata,
            function (err, response) {
              if (err) {
                reject(err);
              } else {
                resolve(response);
              }
            }
          );
        }),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    if (e instanceof RpcError) {
      return e;
    }
  }
};